import { getParameterByName } from '../../utils/queryString.utils';

const usePpRatingParams = () => {
  const ppRatingParam = getParameterByName('pp_rating');
  const ppRating: number | undefined =
    !ppRatingParam || +ppRatingParam < 0 || +ppRatingParam > 5
      ? undefined
      : +ppRatingParam;
  return {
    ppRating,
  };
};

export { usePpRatingParams };
